module.exports = __webpack_public_path__ + "img/logo-lavepay.3c115fae.png";